// extracted by mini-css-extract-plugin
export default {"actions":"style_actions__U2OCv","actions_btn":"style_actions_btn__YbIvZ"};